"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var ReportExternal = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "transparent", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 16 16", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "report-external" },
            react_1.default.createElement("path", { id: "Icon", stroke: "currentcolor", d: "M5.33327 8.66674L5.33327 11.3334M10.6666 7.3334L10.6666 11.3334M7.99994 4.66674L7.99994 11.3334M13.9999 8.00007L13.9999 10.8001C13.9999 11.9202 13.9999 12.4802 13.782 12.9081C13.5902 13.2844 13.2842 13.5903 12.9079 13.7821C12.4801 14.0001 11.92 14.0001 10.7999 14.0001L5.19994 14.0001C4.07983 14.0001 3.51978 14.0001 3.09196 13.7821C2.71563 13.5903 2.40967 13.2844 2.21793 12.908C1.99994 12.4802 1.99994 11.9202 1.99994 10.8001L1.99994 5.20007C1.99994 4.07996 1.99994 3.51991 2.21793 3.09209C2.40967 2.71576 2.71563 2.4098 3.09196 2.21806C3.51978 2.00007 4.07983 2.00007 5.19994 2.00007L7.99994 2.00007M11.2524 1.91919L14.0808 1.91919M14.0808 1.91919L14.0808 4.74762M14.0808 1.91919L11.2524 4.74762", "stroke-width": "1.33", "stroke-linecap": "round", "stroke-linejoin": "round" }))));
};
exports.default = ReportExternal;
